





































































































































import {Component, Vue, Ref, Watch} from "vue-property-decorator"
import Pagination from "@/components/Pagination.vue"
import Gravatar from "@/components/Gravatar.vue"
import {vxm} from "@/store"

@Component({components: {Pagination, Gravatar}})
export default class NotificationList extends Vue {

  private page: number = 1
  private per_page: number = 10
  private loading: boolean = false
  private show_filter: boolean = false

  private filter_statuses: string[] = []

  @Ref() private filter_node!: Node

  get notifications() {
    return vxm.notification.notifications
  }

  get page_num() {
    return Math.ceil(vxm.notification.all_count / this.per_page)
  }

  get is_filtered(): boolean {
    return this.filter_statuses.length !== 0
  }

  async mounted() {
    this.filter_statuses = vxm.app.notification_filter.statuses || []
    this.fetch()
  }

  toggleFilter() {
    this.show_filter = !this.show_filter
    if (this.show_filter) {
      document.body.addEventListener("click", this.onClickOutSide)
    }
  }

  onClickOutSide(e: MouseEvent) {
    const target = <Node>e.target
    if (this.filter_node.contains(target)) return

    this.show_filter = false
    document.body.removeEventListener("click", this.onClickOutSide)
  }

  async onClickCancel(notification_id: number) {
    if (confirm("この通知をキャンセルします。")) {
      try {
        await vxm.notification.cancel(notification_id)
        await vxm.notification.fetchNotifications({force: true, page: this.page})
      } catch (e) {
        alert("エラー")
        console.error(e)
      }
    }
  }

  onClickPager(page: number) {
    this.page = page
    this.fetch()
  }

  onClickPrevPage() {
    this.page--
    this.fetch()
  }

  onClickNextPage() {
    this.page++
    this.fetch()
  }

  async fetch() {
    this.loading = true
    await vxm.notification.fetchNotifications({
      force : true,
      page  : this.page,
      filter: {statuses: this.filter_statuses}
    })
    this.loading = false
  }

  @Watch("filter_statuses")
  async watchFilterStatuses() {

    const filter = vxm.app.notification_filter
    filter.statuses = this.filter_statuses
    await vxm.app.updateNotificationFilter(filter)

    this.page = 1
    await this.fetch()
  }

}
